const flowFormRoutes = [
  {
    path: "/flow/:id",
    name: "doFlow",
    component: () => import("@/domain/Flows/FlowForm/presentation/pages/DoFlowPage.vue"),
    meta: { requiresAuth: false },
  },
];

export default flowFormRoutes;
